<template>
	<div class="Flex">
		<slot></slot>
	</div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
onMounted(() => {})

onUnmounted(() => {})
</script>

<style scoped>
.Flex {
	display: flex;
	flex-wrap: wrap;
	box-sizing: border-box;
}
</style>
